import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_024",
  "use": "icon-su_024-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_024\"><defs><style>#icon-su_024 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_024_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_024_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><rect class=\"cls-2\" x=\"6\" y=\"13\" width=\"12\" height=\"2\" /><rect class=\"cls-2\" x=\"6\" y=\"9\" width=\"12\" height=\"2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol